import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import ComponentEquipmentCategoryListTable from './Components';
import { RootState } from '../../../redux/rootState';
import { exportToExcelData } from '../../../Common/PageHeader/helper';

function ScreenEquipmentCategoryList() {
  const { EquipmentCategoryListData } = useSelector((state: RootState) => state.ListEquipmentCategoryReducer);

  const excelData = useMemo(() => EquipmentCategoryListData?.Data?.map((item) => {
    const transformedDataItems = {
      Category: item?.Description,
    };
    return transformedDataItems;
  }), [EquipmentCategoryListData]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Equipment_category_list',
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="EQUIPMENT CATEGORY" downloadExcel={downloadExcel} />
      </Grid>
      <div className="whiteSpace" />
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <ComponentEquipmentCategoryListTable />
      </Grid>
    </Grid>
  );
}

export default ScreenEquipmentCategoryList;
